import loader from '@assets/gifs/load.gif';
import styled from 'styled-components';

const FooterLoader = () => {
  return (
    <FooterLoaderWrapper data-testid='footer-loader'>
      <LoaderImage src={loader} alt='Loading' />
      <LoaderText data-testid='footer-loading-text'>Loading...</LoaderText>
    </FooterLoaderWrapper>
  );
};

export const FooterLoaderWrapper = styled.div`
  padding-top: 15px;
  display: flex;
  justify-content: center;
`;

export const LoaderImage = styled.img`
  height: 25px;
`;

export const LoaderText = styled.p`
  margin-left: 10px;
  font-size: large;
`;

export default FooterLoader;
